/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Blog_Reading_ZeroInputs */

const en_blog_reading_zero = /** @type {(inputs: Blog_Reading_ZeroInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} min read`)
};

const lv_blog_reading_zero = /** @type {(inputs: Blog_Reading_ZeroInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} min lasīšanas`)
};

/**
* | output |
* | --- |
* | "{count} min read" |
*
* @param {Blog_Reading_ZeroInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const blog_reading_zero = /** @type {((inputs: Blog_Reading_ZeroInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Reading_ZeroInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_blog_reading_zero(inputs)
	return en_blog_reading_zero(inputs)
});